<script setup lang="ts">
import { PlusIcon } from '@heroicons/vue/solid';
</script>

<template>
  <button
    class="h-[289px] w-[100px] bg-gray-50 flex items-center justify-center"
  >
    <PlusIcon class="h-6 w-6" />
  </button>
</template>
